import { render, staticRenderFns } from "./otherInfos.vue?vue&type=template&id=6e970fba&scoped=true&"
import script from "./otherInfos.vue?vue&type=script&lang=js&"
export * from "./otherInfos.vue?vue&type=script&lang=js&"
import style0 from "./otherInfos.vue?vue&type=style&index=0&id=6e970fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e970fba",
  null
  
)

export default component.exports